export class Me {
  id: string;
  name: string;
  email: string;
  mobile_no: string;
  image: string;

  constructor(args: any) {
    this.id = args.id;
    this.name = args.name;
    this.email = args.email;
    this.mobile_no = args.mobile_no;
    this.image = args.image;
  }
}
